<app-modal #modal class="diary-config-modal">
  <div class="modal-header mb-0">
    <h2 class="modal-title">E-Diary Settings</h2>
    <button type="button" class="close" (click)="modal.hide()" aria-label="Close">
      <span aria-hidden="true"><i class="far fa-times"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="form">

      @if (diaryConfig.mandatoryNotification) {
        <div class="mandatory-notification">
          <h2>Mandatory Reminder</h2>
          <p>Email reminders are required for this eDiary and cannot be disabled to ensure compliance.</p>
        </div>
      }

      <div class="form-group">
        <label class="timezone-label">Patient Timezone <sup *ngIf="isRequired('timezone')">*</sup></label>
        <app-timezone-select #timezoneSelect (optionChanged)="onTimezoneChanged($event)" [parentForm]="form" controlName="timezone"></app-timezone-select>
      </div>

      @if (!isIntraDay) {
      <section>
        <div class="reminder-toggles">
          <div class="checkbox-wrap">
            <label class="checkbox-label" for="remindersEnabled" style="margin-left: 0;">E-Diary Reminders</label>
          </div>
        </div>

        <div class="reminder-toggles">
          <div class="app-email">
            <div class="checkbox-wrap">
              <label class="checkbox" [ngClass]="{'checked': form.get('remindersEnabled').value}">
                <input type="checkbox" id="remindersEnabled" formControlName="remindersEnabled" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="remindersEnabled">App</label>
            </div>

            <div class="checkbox-wrap">
              <label class="checkbox" [ngClass]="{'checked': form.get('emailRemindersEnabled').value}" [style.cursor]="diaryConfig.mandatoryNotification ? 'not-allowed' : 'pointer'">
                <input type="checkbox" id="emailRemindersEnabled" formControlName="emailRemindersEnabled" value="true" [disabled]="diaryConfig.mandatoryNotification">
                <span></span>
              </label>
              <label class="checkbox-label" for="emailRemindersEnabled">Email</label>
            </div>
          </div>
        </div>

        <div class="section-inner" [ngClass]="{ 'visibility-hidden': form.get('remindersEnabled').value !== true && form.get('emailRemindersEnabled').value !== true }">
          <div class="field-group">
            <div class="field-group-inner">
              <label>Reminder Time <sup *ngIf="isRequired('reminderTime')">*</sup></label>
              <div class="input-wrap">
                <div class="fake-field disabled" *ngIf="editingDisabled">{{ form.get('reminderTime').value }}</div>
                <app-input-timepicker formControlName="reminderTime" *ngIf="!editingDisabled"></app-input-timepicker>
              </div>
            </div>
            <span class="helper-text" *ngIf="shouldShowUtcTime('reminderTime')">{{ form.get('reminderTimeUtc').value }} UTC</span>
          </div>
        </div>
      </section>
      }

      @if (isIntraDay) {
      <section>
        <div class="reminder-toggles">
          <div class="checkbox-wrap">
            <label class="checkbox-label" style="margin-left: 0;">Patient Reminder Times</label>
          </div>
        </div>

        <div class="on-demand-reminder-times">
          @for (t of intraDayReminderTimes; track t) {
            <div class="on-demand-reminder-time-row">
              <span class="on-demand-reminder-time-value">{{ formatReminderTime(t) }}</span>
              <button type="button" class="on-demand-reminder-remove-btn" (click)="onRemoveReminderTimeClicked(t)" title="Remove">
                <i class="far fa-times"></i>
              </button>
            </div>
          }
          @if (intraDayReminderTimes.length === 0) {
            <p class="text-muted" style="font-size: 0.85rem; margin: 8px 0 0 0;">No reminder times configured.</p>
          }
        </div>

        <div class="on-demand-add-row">
          <div class="input-wrap type-time">
            <mat-form-field>
              <input type="time" matInput [(ngModel)]="newReminderTime" [ngModelOptions]="{standalone: true}">
            </mat-form-field>
          </div>
          <button type="button" class="btn btn-outline btn-outline-slim" (click)="addReminderTime()" [disabled]="!newReminderTime">Add</button>
        </div>

        <div class="reminder-toggles" style="margin-top: 12px;">
          <div class="checkbox-wrap">
            <label class="checkbox-label" style="margin-left: 0;">E-Diary Reminders</label>
          </div>
        </div>

        <div class="reminder-toggles">
          <div class="app-email">
            <div class="checkbox-wrap">
              <label class="checkbox" [ngClass]="{'checked': form.get('remindersEnabled').value}">
                <input type="checkbox" id="remindersEnabled" formControlName="remindersEnabled" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="remindersEnabled">App</label>
            </div>

            <div class="checkbox-wrap">
              <label class="checkbox" [ngClass]="{'checked': form.get('emailRemindersEnabled').value}" [style.cursor]="diaryConfig.mandatoryNotification ? 'not-allowed' : 'pointer'">
                <input type="checkbox" id="emailRemindersEnabled" formControlName="emailRemindersEnabled" value="true" [disabled]="diaryConfig.mandatoryNotification">
                <span></span>
              </label>
              <label class="checkbox-label" for="emailRemindersEnabled">Email</label>
            </div>
          </div>
        </div>
      </section>
      }

      <div class="two-column-inputs">
        <div class="field-group one-third">
          <div class="field-group-inner">
            <label>E-Diary First Date <sup *ngIf="isRequired('startDate')">*</sup></label>
            <div class="input-wrap">
              <app-datepickerv2-input [parentForm]="form" controlName="startDate"></app-datepickerv2-input>
            </div>
          </div>
        </div>

        <div class="field-group one-third">
          <div class="field-group-inner">
            <label>E-diary Last Date <sup *ngIf="isRequired('endDate')">*</sup></label>
            <div class="input-wrap">
              <app-datepickerv2-input [parentForm]="form" controlName="endDate"></app-datepickerv2-input>
            </div>
          </div>
        </div>
      </div>

    </form>
  </div>

  <div class="modal-footer">
    <button type="button" (click)="onFormSubmit()" [disabled]="form.invalid || form.get('isBusy').value" class="btn btn-primary">
      <span *ngIf="form.get('isBusy').value">
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </span>
      <span *ngIf="!form.get('isBusy').value">Update Settings</span>
    </button>
  </div>
</app-modal>

<app-confirm-action-modal
  #confirmRemoveReminderModal
  title="Remove Reminder"
  message="Are you sure you want to remove this reminder time?"
  confirmBtnText="Remove"
  (confirmed)="removeReminderTime($event)">
</app-confirm-action-modal>
